export const NEW_CHAT_TOKEN = 'new-chat';
